import Handler from "../Handler";

class TerminatePrivateTableFailureHandler extends Handler {
  execute(message) {
    this.service.processTerminatePrivateTableFailure();
  }
}

export default TerminatePrivateTableFailureHandler;
